import { Alert, Badge } from '@mantine/core';
import { IconBrandGoogle, IconLogout } from '@tabler/icons-react';
import { useAccount } from './AccountProvider';
import { ActionButton, Part } from '../../ui/SettingsParts';
import { Brand, Copy } from '../../ui/Brand';

const WHY = '{flow} is invite only. Sign in with an invited Google account to use it.';

/** Sign in with Google (through Clerk), see who you are, sign out. */
export const AccountCard = () => {
  const { state, signIn, signOut } = useAccount();
  const signedIn = state.status === 'signedIn';
  const who = signedIn ? (state.user?.name ?? state.user?.email ?? 'Signed in') : 'Account';
  const lead =
    state.status === 'disabled' ? "Accounts aren't set up in this build."
    : state.status === 'loading' ? 'Connecting…'
    : state.status === 'unavailable' ? <>Can't reach the sign-in service right now (offline?). <Brand /> keeps working on this device and checks again when you're back online.</>
    : signedIn ? (state.user?.email ?? null)
    : <Copy>{WHY}</Copy>;
  return (
    <Part
      title={who}
      right={signedIn && state.user?.role === 'admin' ? <Badge size="xs" variant="light">admin</Badge> : undefined}
      lead={lead}
      actions={
        signedIn ? <ActionButton leftSection={<IconLogout size={14} />} onClick={() => void signOut()}>Sign out</ActionButton>
        : state.status === 'unavailable' ? <ActionButton onClick={() => location.reload()}>Try again</ActionButton>
        : state.status === 'idle' || state.status === 'signedOut' ? <ActionButton primary leftSection={<IconBrandGoogle size={14} />} onClick={signIn} data-testid="sign-in">Sign in with Google</ActionButton>
        : undefined
      }
    >
      {signedIn && state.problem && <Alert color="yellow"><Copy>{state.problem}</Copy></Alert>}
    </Part>
  );
};